import { useState } from "react";

import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { NormalText } from "@/components/text/NormalText";

export function FeedbackForm({
  title,
  onSubmit,
}: {
  title: string;
  onSubmit: (feedback: string) => void;
}) {
  const [feedback, setFeedback] = useState("");

  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>
      <textarea
        className="w-full rounded-lg border p-3 text-sm"
        placeholder="Share your feedback..."
        rows={4}
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
      />
      <CancelButtons
        positiveText="Submit Feedback"
        negativeText={null}
        onPositive={() => {
          onSubmit(feedback);
        }}
        onNegative={null}
      />
    </div>
  );
}
